import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
//import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
//import "bootstrap/dist/js/bootstrap.bundle.min";

import { store, persistor } from "./store";

import App from "./App";
import ErrorBoundary from "./components/common/ErrorBoundary";
import ChatProvider from "./context/ChatProvider";
import { NotificationProvider } from "./context/NotificationContext";
import { SocketProvider } from "./context/SocketProvider";
import { EpkWizardProvider } from "./context/EpkWizardContext";
import AuthBootstrap from "./components/Auth/AuthBootstrap";

import './i18n';
import { ThemeProvider } from './context/ThemeContext';
import { CookieConsentProvider } from './context/CookieConsentContext';

const root = createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AuthBootstrap>
        <ThemeProvider>
          <CookieConsentProvider>
            <SocketProvider>
              <BrowserRouter>
                <ErrorBoundary>
                  <EpkWizardProvider>
                    <ChatProvider>
                      <NotificationProvider>
                        <App />
                      </NotificationProvider>
                    </ChatProvider>
                  </EpkWizardProvider>
                </ErrorBoundary>
              </BrowserRouter>
            </SocketProvider>
          </CookieConsentProvider>
        </ThemeProvider>
      </AuthBootstrap>
    </PersistGate>
  </Provider>
);